import React from 'react';
import { useParams } from 'react-router-dom';
import { researchProjects } from '../data/projects';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ResearchDetailCard from '../components/ResearchDetailCard';

const Project = () => {
  const { slug } = useParams();
  const project = researchProjects.find(p => p.slug === slug);

  if (!project) {
    return <div style={{ padding: '6rem', color: '#fff', textAlign: 'center' }}><h1>Project not found</h1></div>;
  }

  const hasSponsor = project.orgs?.some(org => org.name === 'Sponsor' && org.image && org.image !== '/question-mark.webp');

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh' }}>
      <Header />
      <main id="scroll-container" style={{ padding: '6rem 2rem 4rem', display: 'flex', justifyContent: 'center' }}>
        <ResearchDetailCard
          {...project}
          onSponsor={!hasSponsor ? () => window.open(`https://donate.doquantum.org/${slug}`, '_blank') : undefined}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Project;